import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { makeGetCall } from '../../effects/requests'
import { ApiResponseType, LegalsType } from '../../types'
import { endPoints } from '../../utils/endpoints'
import { emptyFunction } from '../../utils'

const LegalsV2: React.FC<any> = () => {

    const params = useParams();
    const navigate = useNavigate();

    const [legals, setLegals] = useState<string | null>();

    const getTncAndPP = (url: string) => {
        makeGetCall(url).then((res: ApiResponseType<LegalsType>) => {
            setLegals(res.data?.text || null)
        }).catch(emptyFunction)
    }

    useEffect(() => {
        const url = params?.type === 'pp' ? endPoints.PP : endPoints.TERMS;
        getTncAndPP(url)
    }, [])


    const title = params?.type === 'pp' ? 'Privacy Policy' : 'Terms & Conditions'

    return (
        <div className="register-layout">
            <div className="register-layout__right">
                <div className="register-layout__right-overlay" />
                <img
                    src='/assets/images/film-set.png'
                    alt="film production"
                    className="onboarding-login-image"
                />
                <div className="onboarding-login-year">
                    <img
                        src='/assets/images/yellow-6th.png'
                        alt="logo"
                    />
                </div>
            </div>
            <div className="register-layout__left">
                <div className="register-layout__content">
                    <div className='inner-content policy-page text-center ms-auto'>
                        <div className='top-heading text-start'>
                            <h3 onClick={() => { navigate(-1) }}>
                                <button className="onboarding-login-back-btn">
                                    <img
                                        src='/assets/images/black-arrow-left-side.svg'
                                        alt="back"
                                        className="onboarding-login-back-icon"
                                    />
                                </button>
                                <span style={{ color: '#000' }}>{title}</span>
                            </h3>
                        </div>
                        <div className='policy-page-data text-start'>
                            <div dangerouslySetInnerHTML={{ __html: legals || '' }} className='page-scroll' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LegalsV2;
